<script setup>
import { ArrowsPointingOutIcon, TrashIcon } from '@heroicons/vue/24/solid'
import { nodeViewProps } from "@tiptap/vue-3"
import { computed } from "vue"

const props = defineProps({
  removable: {
    type: Boolean,
    default: true,
  },
  ...nodeViewProps,
})

const editable = computed(() => {
  return props.editor.options.hasOwnProperty('editable') ? props.editor.options.editable : true
})
</script>

<template>
  <div
    v-if="editable"
    :draggable="node.type.spec.draggable"
    :class="{ 'ring-1 ring-indigo-500': selected }"
  >
    <div class="flex">
      <div class="flex items-center w-content -top-7 bg-gray-50 shadow rounded overflow-hidden" :class="{ 'ring-indigo-400': selected }">
        <div v-if="node.type.spec.draggable" class="cursor-move p-1" data-drag-handle>
          <ArrowsPointingOutIcon class="w-4 h-4 text-gray-800" />
        </div>
        <button v-if="removable" class="p-1" type="button" @click.prevent="deleteNode" v-tooltip="__('Delete')">
          <TrashIcon class="w-4 h-4 text-gray-800" />
        </button>
        <slot name="tools"></slot>
      </div>
    </div>
    <div class="border border-gray-100 p-1.5">
      <slot name="content" :editable="editable"></slot>
    </div>
  </div>
  <slot v-else name="content" :editable="editable"></slot>
</template>
